

@if (!isLoading) {
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a routerLinkActive="active" [routerLink]="['../../projects']"> LLM Playground </a>
      </li>
      <li class="breadcrumb-item">
        <a routerLinkActive="active" [routerLink]="['../../projects', batch?.project.id]"> {{ batch?.project.name }} </a>
      </li>
      <li class="breadcrumb-item active" aria-current="page">
        {{ batch?.name }}
      </li>
      <li class="ms-auto">
        <a href="#" (click)="onDownloadBatchResults($event, batch.id)">
          Download
        </a>
      </li>
    </ol>
  </nav>
  <table class="table table-bordered table-hover table-resizable-columns">
    <thead class="table-dark">
      <tr>
        <th>Row</th>
        @for (header of batch.csvData[0]; track header) {
          <th
            [appResizableColumn]="true"
            class="resizable-header"
            >{{header}}@if (header === 'MODEL') {
            <span>*</span>
          }
        </th>
      }
    </tr>
  </thead>
  <tbody>
    @for (row of batch.csvData.slice(1); track row; let i = $index) {
      <tr>
        <td>{{ i + 1}}</td>
        @for (cell of row; track cell) {
          <td>
            <pre class="text-pre-wrap scrollable-cell">{{ cell }}</pre>
          </td>
        }
      </tr>
    }
  </tbody>
</table>
* Azure model names for individual responses may contain only the base model version, not the variant actually used.
} @else {
  <div><mat-spinner diameter="30" /></div>
}
